//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LibraryLendingDisplayItem extends ItemBase {
    DueDate: string | null = null;
    LoanedByTeacherID: string | null = null;
    LoanedByTeacherName: string | null = null;
    LoanedOn: string | null = null;
    ID: string | null = null;
    IsCheckedIn: boolean = false;
    ItemName: string | null = null;
    ItemType: string | null = null;
    PrivateNote: string | null = null;
    PublicNote: string | null = null;
    Publisher: string | null = null;
    SerialNumber: string | null = null;
    ShareWithSchool: boolean = false;
    StudentID: string | null = null;
    StudentName: string | null = null;
    TeacherID: string | null = null;
    TeacherName: string | null = null;
    Editable: boolean = false;
    Loanable: boolean = false;
    Deletable: boolean = false;

    constructor(initializer?: Partial<LibraryLendingDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryLendingDisplayItem";
}
